module.exports = __webpack_public_path__ + "img/图片15.8b408152.jpg";